// extracted by mini-css-extract-plugin
module.exports = {"container":"TextSeparator_container__x0EXs","sepHolder":"TextSeparator_sepHolder__rBHnH","sepHolderLine":"TextSeparator_sepHolderLine__FuQ2e","text":"TextSeparator_text__Mah84"};